import routes from 'src/utils/routes/routes';

export const isGroupPurchase = (): boolean => {
  const currentLocation = window.location.pathname;
  const groupPurchaseRoutes = [routes.groupPurchaseLanding, routes.groupPurchaseSummary];
  return groupPurchaseRoutes.some((route) => currentLocation.includes(route));
};
